
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("lRfBG", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $5091b8631cc9cb60$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Portuguese (Brazil)
var $5091b8631cc9cb60$export$2e2bcd8739ae039 = {
    'fabric.linkPicker.button.cancel': 'Cancelar',
    'fabric.linkPicker.button.insert': 'Inserir',
    'fabric.linkPicker.button.save': 'Salvar',
    'fabric.linkPicker.clearLink': 'Limpar',
    'fabric.linkPicker.clearLinkText': 'Limpar texto',
    'fabric.linkPicker.hyperlink.searchLinkResults': '{count, plural, =0 {nenhum resultado encontrado} one {{count,number} resultado encontrado} other {{count,number} resultados encontrados}}',
    'fabric.linkPicker.linkAriaLabel': 'Digite ou cole o link no campo',
    'fabric.linkPicker.linkHelperTextAriaLabel': "Texto auxiliar de exibi\xe7\xe3o do link",
    'fabric.linkPicker.linkHelperTextLabel': "D\xea um t\xedtulo ou uma descri\xe7\xe3o a este link",
    'fabric.linkPicker.linkInvalid': "Informe uma URL v\xe1lida.",
    'fabric.linkPicker.linkLabel': 'Link',
    'fabric.linkPicker.linkPlaceholder': 'Cole o link',
    'fabric.linkPicker.linkTextAriaLabel': "Texto para exibi\xe7\xe3o do link",
    'fabric.linkPicker.linkTextLabel': "Texto para exibi\xe7\xe3o (opcional)",
    'fabric.linkPicker.linkTextPlaceholder': 'Texto a ser exibido',
    'fabric.linkPicker.listTitle.recentlyViewed': 'Visualizado recentemente',
    'fabric.linkPicker.listTitle.results': 'Resultados',
    'fabric.linkPicker.search.error.description': "Atualize a p\xe1gina ou fale com o <a>Suporte da Atlassian</a> se o erro persistir.",
    'fabric.linkPicker.search.error.heading': 'Houve alguns problemas ao carregar os dados.',
    'fabric.linkPicker.search.error.retry': 'Atualizar',
    'fabric.linkPicker.search.linkAriaLabel': "As sugest\xf5es v\xe3o aparecer abaixo \xe0 medida que voc\xea digita no campo",
    'fabric.linkPicker.search.linkLabel': 'Pesquise ou cole o link',
    'fabric.linkPicker.search.linkPlaceholder': 'Encontre links recentes ou cole um link novo',
    'fabric.linkPicker.search.noResults.description': 'Tente de novo usando outro termo.',
    'fabric.linkPicker.search.noResults.heading': "N\xe3o foi poss\xedvel encontrar nenhum resultado para a pesquisa.",
    'fabric.linkPicker.status.submitting': 'Enviando',
    'fabric.linkPicker.time.message.updated': "\xdaltima atualiza\xe7\xe3o: {time}",
    'fabric.linkPicker.time.message.viewed': "\xdaltima visualiza\xe7\xe3o: {time}",
    'fabric.linkPicker.unhandledError.description': "Tente recarregar a p\xe1gina.",
    'fabric.linkPicker.unhandledError.heading': 'Algo deu errado!'
};

});


//# sourceMappingURL=pt_BR.4d87c8f0.js.map
